import React from 'react';
import { Modal, Button } from 'antd';

interface SavePreviewModalProps {
    visible: boolean;
    imageUrl: string | null;
    previewUrl?: string | null;
    onCancel: () => void;
    onUpload: () => void;
    isUpdating: boolean;
    isBaseTemplate?: boolean;
}

export const SavePreviewModal: React.FC<SavePreviewModalProps> = ({
    visible,
    imageUrl,
    previewUrl,
    onCancel,
    onUpload,
    isUpdating,
    isBaseTemplate
}) => {
    const effectiveIsUpdating = isUpdating && !isBaseTemplate;
    return (
        <Modal
            title={effectiveIsUpdating ? "Update Template Preview" : "Save Template Preview"}
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="upload" type="primary" onClick={onUpload}>
                    {effectiveIsUpdating ? "Update & Save" : "Save as New Template"}
                </Button>
            ]}
            width={800}
        >
            <div style={{ textAlign: 'center' }}>
                {isBaseTemplate && (
                    <div style={{ marginBottom: '16px', color: '#faad14', fontWeight: 'bold' }}>
                        Note: This is a base template. It will be saved as a new copy in your organization.
                    </div>
                )}
                <p>Verify the captured preview image before saving:</p>
                {imageUrl ? (
                    <div style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        background: '#f9f9f9',
                        maxHeight: '500px',
                        overflow: 'auto'
                    }}>
                        <img
                            src={imageUrl}
                            alt="Template Preview"
                            style={{ maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto' }}
                        />
                        <div style={{ marginTop: '16px', textAlign: 'left', fontSize: '12px' }}>
                            <div style={{ marginBottom: '8px' }}>
                                <strong>Current Template Preview URL:</strong>
                                <div style={{ wordBreak: 'break-all', color: previewUrl ? '#666' : '#ff4d4f' }}>
                                    {previewUrl || '(Not set - will be uploaded on save)'}
                                </div>
                            </div>
                            <div>
                                <strong>Generated Local Preview URL:</strong>
                                <div style={{ wordBreak: 'break-all', color: '#1890ff' }}>
                                    {imageUrl || '(Generating...)'}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div style={{ padding: '40px', background: '#f0f0f0', borderRadius: '4px' }}>
                        Capturing preview...
                    </div>
                )}
            </div>
        </Modal>
    );
};
